















import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {AntennaType} from '@/model/lora/AntennaType';

import {ILoraHardwareService} from '@/services/lora/ILoraHardware.service';

import LoraHardwareStore from '@/store/lora/LoraHardware.store';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class LoraAntennaEditor extends Mixins<BaseComponent>(BaseComponent) {

  @Inject(Symbol.for('ILoraHardwareService'))
  private loraHardwareService!: ILoraHardwareService;

  private loraHardwareStore: LoraHardwareStore = getModule(LoraHardwareStore, this.$store);

  @Prop()
  private antenna!: AntennaType;
}
